import { useState } from "react";
import { Lock, ArrowRight, Eye, EyeOff } from "lucide-react";

const BETA_CODE = "odesie-beta-2026";

const BetaGatePage = ({ onUnlock }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.trim().toLowerCase() === BETA_CODE) {
      localStorage.setItem("odesie_beta_access", "granted");
      onUnlock();
    } else {
      setError("Invalid access code. Please try again.");
      setTimeout(() => setError(""), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1520] flex items-center justify-center p-6" data-testid="beta-gate">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-10">
          <img src="/odesie-logo-white.png" alt="Odesie" className="h-10 opacity-90" />
        </div>

        {/* Card */}
        <div className="bg-[#111D2E] border border-white/[0.06] rounded-2xl p-8 shadow-2xl">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-blue-600/10 border border-blue-500/20 flex items-center justify-center">
              <Lock className="w-6 h-6 text-blue-400" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-center text-white mb-2">Beta Access</h1>
          <p className="text-sm text-center text-slate-400 mb-8 leading-relaxed">
            Welcome to the <span className="text-blue-400 font-semibold">v0.5 Beta</span> of Odesie LMS.
            Enter your access code to experience the platform.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="beta-code" className="block text-xs font-medium text-slate-400 mb-2 uppercase tracking-wider">
                Access Code
              </label>
              <div className="relative">
                <input
                  id="beta-code"
                  type={show ? "text" : "password"}
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Enter your beta access code"
                  className="w-full px-4 py-3 bg-[#0B1520] border border-white/[0.08] rounded-xl text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500/40 transition-all text-sm"
                  autoComplete="off"
                  data-testid="beta-code-input"
                />
                <button
                  type="button"
                  onClick={() => setShow(!show)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors"
                  aria-label={show ? "Hide code" : "Show code"}
                >
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {error && (
              <p className="text-xs text-red-400 text-center" data-testid="beta-error">{error}</p>
            )}

            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl transition-colors text-sm"
              data-testid="beta-submit-btn"
            >
              Unlock Beta Access <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>

        {/* Footer */}
        <p className="text-center text-[11px] text-slate-500 mt-8">
          Odesie LMS v0.5 Beta &middot; Enterprise Learning Platform
        </p>
      </div>
    </div>
  );
};

export default BetaGatePage;
